import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: null,
};

const getDepartmentInfoSlice = createSlice({
  name: "getDepartmentInfo",
  initialState,
  reducers: {
    getDepartmentInfoStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getDepartmentInfoSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getDepartmentInfoFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  getDepartmentInfoStart,
  getDepartmentInfoSuccess,
  getDepartmentInfoFailed,
} = getDepartmentInfoSlice.actions;

export default getDepartmentInfoSlice.reducer;
